// extracted by mini-css-extract-plugin
export var cardIcon = "_5m-4";
export var checkboxCard = "_5m-0";
export var checkboxCardSelected = "_5m-3";
export var disabled = "_5m-1";
export var outerBorder = "_5m-2";
export var spacerMedium = "_5m-7";
export var spacerSmall = "_5m-6";
export var spacerXsmall = "_5m-5";